export async function useFetchDataFromStoryblok<T = any>(slug: string, resolveRelations?: string[]): Promise<Ref<T>> {
  const runtimeConfig = useRuntimeConfig()
  const { locale } = useI18n()
  const language = locale.value === 'en' ? 'default' : locale.value

  return await useAsyncStoryblok(
    slug,
    {
      version: runtimeConfig.public.env === 'development' ? 'draft' : 'published',
      language,
      resolve_relations: resolveRelations,
      resolve_links: 'story',
      resolve_assets: 0
    },
    {
      resolveRelations: resolveRelations,
      resolveLinks: 'story'
    }
  )
}
